import { render } from "./declareSubmit.vue?vue&type=template&id=3fd5393f&scoped=true"
import script from "./declareSubmit.vue?vue&type=script&lang=js"
export * from "./declareSubmit.vue?vue&type=script&lang=js"

import "./declareSubmit.vue?vue&type=style&index=0&id=3fd5393f&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd5393f"]])

export default __exports__